module.exports = {
  AllPassages: ["Genre", "Length", "Grade", "Book"],
  AllQuestions: ["Passage", "Type", "Skill"],
  ReviewQuestions: ["Passage", "Teacher"]
};
